import { Upload } from 'lucide-react'
import { cn } from '@/lib/utils'

interface FileUploadZoneProps {
  getRootProps: () => any
  getInputProps: () => any
  isDragActive: boolean
  disabled: boolean
}

export function FileUploadZone({
  getRootProps,
  getInputProps,
  isDragActive,
  disabled,
}: FileUploadZoneProps) {
  return (
    <div
      {...getRootProps()}
      className={cn(
        'border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors',
        isDragActive
          ? 'border-blue-500 bg-blue-50'
          : 'border-gray-300 hover:border-gray-400',
        disabled && 'opacity-50 cursor-not-allowed'
      )}
    >
      <input {...getInputProps()} />
      <Upload className='mx-auto h-12 w-12 text-gray-400 mb-4' />
      <p className='text-sm text-gray-600 mb-2'>
        {isDragActive
          ? 'Drop the file here'
          : 'Drag & drop a file here, or click to select'}
      </p>
      <p className='text-xs text-gray-500'>
        Supports CSV, XLS, and XLSX files
      </p>
    </div>
  )
}

